import { gql } from "@apollo/client";

export const userProfileFragment = gql`
    fragment UserProfile on GetUserProfileResponse {
        userDisplayName
        avatarUrl
        pageUrl
        userId
        defaultOrganizationId
        exclusiveLensProgramStatus
    }
`;
